import React, { ReactElement, useState } from 'react';
import { DI, DIProps } from '../../../../Core';
import Onboarding from './Onboarding';

interface Props extends DIProps { }

function NewAccount(props: Props): ReactElement {
    const [planStatus, updatePlanStatus] = useState('_WAITING_'); // _WAITING_ | _PENDING_ | _DONE_
    const [stepStatus, updateStepStatus] = useState('_INPROGRESS_'); // _INPROGRESS_ | _COMPLETED_
    return (
        <Onboarding
            updatePlanStatus={updatePlanStatus}
            updateStepStatus={updateStepStatus}
            newAccount={true}
        />
    )
}
export default DI(NewAccount);